module.exports = __webpack_public_path__ + "static/media/3.760f9032.png";